<template>
    <div class="search__dropdown search__dropdown--vehicle-picker vehicle-picker" :class="vehicleSearchContainerClass" >
        <div class="search__dropdown-arrow"></div>
        <div class="vehicle-picker__panel vehicle-picker__panel--form vehicle-picker__panel--active" data-panel="form">
            <div class="vehicle-picker__panel-body">
                <div class="vehicle-form vehicle-form--layout--search">
                    <div class="vehicle-form__item vehicle-form__item--select">
                        <label for="newsletter-signup">First Name</label>
                        <input type="text" class="form-control" title="First Name" v-model="FirstName">
                    </div>
                    <div class="vehicle-form__item vehicle-form__item--select">
                        <label for="newsletter-signup">Last Name</label>
                        <input type="text" class="form-control" title="Last Name" v-model="LastName">
                    </div>
                    <div class="vehicle-form__item vehicle-form__item--select">
                        <label for="newsletter-signup">Company</label>
                        <input type="text" class="form-control" title="Company" v-model="Company">
                    </div>
                    <div class="vehicle-form__item vehicle-form__item--select">
                        <label for="newsletter-signup">Email</label>
                        <input type="text" class="form-control" title="Email" v-model="Email">
                    </div>
                    
                    <div class="vehicle-form__item">

                    </div>
                </div>
                <div class="vehicle-picker__actions">
                    <button type="button" class="btn btn-primary btn-sm" data-to-panel="list" @click="saveMail">Sign me up!</button>								
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axiosvl from "../../../axios/axios-vl.js";

export default {
    data(){
        return {
            FirstName: '',
            LastName: '',
            Company: '',
            Email: '',
        };
    },
    props: {
        ismailingformopen: {
            type: Boolean
        }
    },
    computed: {
        vehicleSearchContainerClass() {
          return this.ismailingformopen ? "search__dropdown--open" : "";
        },
    },

    methods: {
        saveMail() {
            this.isloading = true;
            this.servermessages = [];
            const mail_subs_uri = this.$store.getters['api/mail_subs_uri'];
            axiosvl.post(mail_subs_uri, {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "LW3SFID": { "value": this.$store.getters.storefront },
                            "LW3CHFNME": { "value": this.FirstName },
                            "LW3CHLNME": { "value": this.LastName },
                            "LW3EMLLST": { "value": this.Email },
                            "LW3CHCOMP": { "value": this.Company },
                        }
                    }
                }
            )
            .then((response) => {
                this.isloading = false;

                const fields = response.data.webroutine.fields;
                console.log(fields);
            })
            .catch((error) => {
                this.isloading = false;
                this.servermessages.push('Something went wrong. Please try again later.');
                console.log(error);
            });
        }
    }
}
</script>